import { SpacingToken } from '@/theme/spacing';
import type { ViewStyle } from 'react-native';

export type AlignSelf = ViewStyle['alignSelf'];
export type AlignItems = ViewStyle['alignItems'];
export type JustifyContent = ViewStyle['justifyContent'];
export type FlexDirection = ViewStyle['flexDirection'];
export type FlexWrap = ViewStyle['flexWrap'];

export type Width = ViewStyle['width'];
export type Height = ViewStyle['height'];
export type MinWidth = ViewStyle['minWidth'];
export type MinHeight = ViewStyle['minHeight'];
export type MaxWidth = ViewStyle['maxWidth'];
export type MaxHeight = ViewStyle['maxHeight'];

export type BoxStyleOptions = {
  padding?: SpacingToken | number;
  paddingX?: SpacingToken | number;
  paddingY?: SpacingToken | number;
  paddingTop?: SpacingToken | number;
  paddingBottom?: SpacingToken | number;
  paddingLeft?: SpacingToken | number;
  paddingRight?: SpacingToken | number;
  margin?: SpacingToken | number;
  marginX?: SpacingToken | number;
  marginY?: SpacingToken | number;
  marginTop?: SpacingToken | number;
  marginBottom?: SpacingToken | number;
  marginLeft?: SpacingToken | number;
  marginRight?: SpacingToken | number;
  gap?: SpacingToken | number;
  gapX?: SpacingToken | number;
  gapY?: SpacingToken | number;
  flex?: number;
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: number;
  borderRadius?: SpacingToken | number;
  borderTopLeftRadius?: SpacingToken | number;
  borderTopRightRadius?: SpacingToken | number;
  borderBottomLeftRadius?: SpacingToken | number;
  borderBottomRightRadius?: SpacingToken | number;
  borderWidth?: SpacingToken | number;
  borderColor?: string;
  backgroundColor?: string;
  width?: Width;
  height?: Height;
  minWidth?: MinWidth;
  minHeight?: MinHeight;
  maxWidth?: MaxWidth;
  maxHeight?: MaxHeight;
  overflow?: 'visible' | 'hidden' | 'scroll';

  position?: ViewStyle['position'];
  zIndex?: ViewStyle['zIndex'];
  bottom?: SpacingToken | number;
  left?: SpacingToken | number;
  right?: SpacingToken | number;
  top?: SpacingToken | number;
};
